export class ScrollToTop {
    constructor() {
      let mybutton = document.querySelector('.arrowTop');
      window.addEventListener('scroll', throttle(scrollFunction() ,14));
  
      function throttle(fn, wait) {
        var time = Date.now();
        return function () {
          if ((time + wait - Date.now()) < 0) {
            scrollFunction();
            time = Date.now()
          }
        }
      }

      function scrollFunction() {
        if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
            mybutton.classList.add('show')
        } else {
            mybutton.classList.remove('show')
        }
      }

    mybutton.addEventListener('click', () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      })
    }
  }
  


// WEBPACK FOOTER //
// ./js/util/scroolToTop.js